export const TAX_REPORT_STATUS = {
  previousYearReturnUploaded: 'PreviousYearReturnUploaded',
  personalInformationConfirmed: 'PersonalInformationConfirmed',
  verifyAllTransactionsImported: 'VerifyAllTransactionsImported',
  bookkeeperReview: 'BookkeeperReview',
  documentsUploaded: 'DocumentsUploaded',
  taxPreparerReview: 'TaxPreparerReview',
  sentForSignature: 'SentForSignature',
  filed: 'Filed',
};

export const TAX_REPORT_STATUS_TITLES = {
  [TAX_REPORT_STATUS.previousYearReturnUploaded]: 'Previous Year Return Uploaded',
  [TAX_REPORT_STATUS.personalInformationConfirmed]: 'Personal Information Confirmed',
  [TAX_REPORT_STATUS.verifyAllTransactionsImported]: 'Verify all transactions imported',
  [TAX_REPORT_STATUS.bookkeeperReview]: 'Bookkeeper Review',
  [TAX_REPORT_STATUS.documentsUploaded]: 'Documents Uploaded',
  [TAX_REPORT_STATUS.taxPreparerReview]: 'Tax Preparer Review',
  [TAX_REPORT_STATUS.sentForSignature]: 'Sent for Signature',
  [TAX_REPORT_STATUS.filed]: 'Filed',
};
